import routesMap from 'src/js/router/helpers/routes-map';

const migrateURL = (pathname) => {
  let isTemplateRoute = false;
  const result = pathname.split('/').reduce((res, route) => {
    if (route === 'template') {
      isTemplateRoute = true;
    }

    if (route.includes('ws-intense-next-') && isTemplateRoute) {
      res.templateSlug = route;
    }

    return res;
  }, {});

  if (result.templateSlug) {
    return routesMap.templateDetails.url({ templateSlug: result.templateSlug });
  }

  return pathname;
};

export default migrateURL;
